import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DateTimeInput } from "@common/dateTimeInput";
import { useMilestoneEdition } from "@planzone/view-models";
import { Props } from "./types";
import { CalendarIcon } from "./calendarIcon";
import styles from "./styles.scss";

function DatesPickers({ milestone, readOnly }: Props) {
  const { t } = useTranslation();
  const [endDate, setEndDate] = React.useState(milestone.endDate);
  const { editMilestone } = useMilestoneEdition(milestone);

  React.useEffect(() => {
    setEndDate(milestone.endDate);
  }, [milestone.endDate]);

  return (
    <div className={styles.datesWrapper}>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("milestoneRetrieval.endDate")}</h3>
        <DateTimeInput
          dateTime={endDate}
          placeholder={t("milestoneRetrieval.endDate")}
          readOnly={readOnly}
          minDate={
            milestone.minStartDate
              ? {
                  year: new Date(milestone.minStartDate).getFullYear(),
                  month: new Date(milestone.minStartDate).getMonth(),
                  day: new Date(milestone.minStartDate).getDate(),
                }
              : undefined
          }
          input={(date) => {
            const nextDate = new Date(date);

            editMilestone({
              milestone,
              nextMilestone: {
                ...milestone,
                endDate:
                  !!milestone.endDate &&
                  nextDate.toISOString() ===
                    new Date(milestone.endDate).toISOString()
                    ? ""
                    : nextDate.toISOString(),
              },
            });
          }}
          clear={() =>
            editMilestone({
              milestone,
              nextMilestone: { ...milestone, endDate: "" },
            })
          }
        />
      </div>
      {milestone.state === "DONE" && (
        <div className={classNames(styles.group, styles.completionDate)}>
          <h3 className={styles.title}>
            {t("milestoneRetrieval.completionDate")}
          </h3>
          <label className={styles.wrapper}>
            <input
              className={styles.input}
              value={
                milestone.completedAt
                  ? new Date(milestone.completedAt).toLocaleDateString()
                  : ""
              }
              readOnly
            />
            <CalendarIcon className={styles.icon} />
          </label>
        </div>
      )}
    </div>
  );
}

export { DatesPickers };
